import { FC, useCallback } from "react";
import { InputLabel, Stack, TextField, Typography } from "@mui/material";

interface CleanConfirmationSectionProps {
  cleanInputValue: string;
  onCleanInputChange(value: string): void;
  placeholder: string;
}
export const CleanConfirmationSection: FC<CleanConfirmationSectionProps> = ({
  cleanInputValue,
  onCleanInputChange,
  placeholder,
}) => {
  const inputValueChangeHandler = useCallback(
    (event: any) => {
      onCleanInputChange(event.target.value);
    },
    [onCleanInputChange],
  );

  return (
    <Stack sx={{ p: 3 }}>
      <InputLabel
        sx={{
          fontSize: 14,
          color: "text.secondary",
          pb: 1,
        }}
      >
        Please type{" "}
        <Typography fontSize={14} fontStyle="italic" component="span">
          {placeholder}
        </Typography>{" "}
        to confirm
      </InputLabel>
      <TextField
        value={cleanInputValue}
        onChange={inputValueChangeHandler}
        name="cleanInputValue"
        placeholder={placeholder}
        fullWidth
      />
    </Stack>
  );
};
